import { Component, OnInit } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.css']
})
export class ValidationComponent implements OnInit {

  constructor( public mobileNav: MobileNavService) { }

  ngOnInit() {
  }

  onClickMe() {
        this.mobileNav.showSideNav();
    }

}
